// extracted by mini-css-extract-plugin
export default {"ldsRing":"Spinner_ldsRing__NPCKe","large":"Spinner_large__elkn2","medium":"Spinner_medium__DO0Ex","small":"Spinner_small__gklgS","lds-ring":"Spinner_lds-ring__A3e-P"};